---
title: Talk to a video avatar
summary: Start a face-to-face video conversation with an expert and interrupt when you need to.
visibility: authenticated
feature: avatars
audience: end-user
section: Using an expert
order: 114
last_verified: 2026-06-19
owner: docs
---

# Talk to a video avatar

Some experts can appear as a talking video avatar.

## Start a session

Open a conversation with an avatar-enabled persona and switch to the **Avatar** tab. The
avatar connects automatically; a status indicator shows **Connecting…** and then **Ready**.
Click **Start Avatar** to begin. If the avatar isn't set up for the deployment, you'll see an
**Avatar Not Configured** message with a link to Settings.

You can also use **Select Avatar** to choose from the available avatar appearances.

## During the conversation

Speak naturally — the avatar listens, thinks, and replies on screen. When it's speaking, an
**Interrupt** button lets you cut in without waiting for it to finish. Depending on how the
persona is set up, the avatar either answers from your knowledge base (with a transcript
beside the video) or is driven by the avatar provider's own AI.

## End a session

Click **End Session** to disconnect the avatar.

## Next

- [Voice conversations](/help/enduser/voice-conversations) — voice without video.
